import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import { setupStore } from '@/store'
import i18n from '@/lang/index'
import '@/utils/browserPatch' //解决element-plus个别组件报错问题，如日期区间选择器
import 'default-passive-events'
import '@/permission'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/styles/index.scss'
import '@/styles/iconfont/iconfont.css'
import 'uno.css'
// 引入高德地图
import { initAMapApiLoader } from '@vuemap/vue-amap'
import '@vuemap/vue-amap/dist/style.css'
initAMapApiLoader({
  key: 'd2f5b4e762e560632d7a4525b59def23',
  securityJsCode: '317bd9de82679a8140e1a0db9a7d0e4a',
  version: '2.0',
  plugins: ['AMap.PlaceSearch'] // 必须显式声明插件
})

const app = createApp(App)
setupStore(app)
app.use(router)
app.use(i18n)
app.mount('#app')
